/** ngx-charts series shape used by the "New Account Creation" chart. */
export type ChartSeries = {
    name: string;
    series: { name: string; value: number }[];
};

export type TimespanOption = {
    readAs: string;
    days: number | null;
};

export const TIMESPAN_OPTIONS: TimespanOption[] = [
    { readAs: 'Total', days: null },
    { readAs: '30 Days', days: 30 },
    { readAs: '60 Days', days: 60 },
    { readAs: '90 Days', days: 90 },
];
